module.exports = __webpack_public_path__ + "images/fa-about-us.jpg";